module.exports = __webpack_public_path__ + "static/media/p-user.450be52f.png";